import React from "react";

/* eslint-disable max-len */
export default function AdminRecommendIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} viewBox="0 0 30 30">
            <g data-name="\u30B0\u30EB\u30FC\u30D7 552">
                <g data-name="\u30B0\u30EB\u30FC\u30D7 450" fill="#9c9c9c">
                    <path
                        data-name="\u30D1\u30B9 8010"
                        d="M19.677 2.007a1.019 1.019 0 00-.947.906c-1.29 7.991-4.446 10.264-4.446 10.264a.76.76 0 00-.1.387l-.151 11.7a.743.743 0 00.755.74h10.1a2.941 2.941 0 002.82-2.033l2.319-9.531a1.776 1.776 0 00-1.8-1.906h-6.938a.555.555 0 01-.419-.187.528.528 0 01-.123-.433l.8-4.785c.755-5.512-1.866-5.119-1.866-5.119z"
                        transform="translate(-40 -15) translate(43 18) translate(-5.795 -2.001)"
                    />
                    <path
                        data-name="\u30D1\u30B9 8011"
                        d="M5.888 18.856a.3.3 0 00-.3.233L2.657 30.617a.182.182 0 00.039.164.187.187 0 00.154.069h5.608a.187.187 0 00.193-.189V18.919a.071.071 0 00-.071-.069H5.888z"
                        transform="translate(-40 -15) translate(43 18) translate(-2.416 -6.85)"
                    />
                </g>
            </g>
        </svg>
    );
}
